module.exports = __webpack_public_path__ + "img/inventario_4.79e8d728.png";